import React from 'react';
import { LFC } from '../Legacy';
import { remInPx } from './Utils';

export type SpinnerProps = React.HTMLProps<SVGSVGElement> & { size?: number, stroke?: number };
export const Spinner: LFC<SpinnerProps> = props => {
    // eslint-disable-next-line prefer-const
    let { size, stroke, ...htmlProps } = props;
    size = size ?? 2.5;
    stroke = stroke ?? 3;
    return <svg width={remInPx(size)} height={remInPx(size)} {...(htmlProps as any)} viewBox="0 0 36 36">
        <defs>
            <linearGradient x1="8.042%" y1="0%" x2="65.682%" y2="23.865%" id="a">
                <stop stopColor="currentColor" stopOpacity="0" offset="0%" />
                <stop stopColor="currentColor" stopOpacity=".631" offset="63.146%" />
                <stop stopColor="currentColor" offset="100%" />
            </linearGradient>
        </defs>
        <g fill="none" fillRule="evenodd">
            <g transform={`scale(${(36 - stroke) / 36}) translate(${stroke / 2} ${stroke / 2})`}>
                <path d="M36 18c0-9.94-8.06-18-18-18" id="Oval-2" stroke="url(#a)" strokeWidth={stroke}>
                    <animateTransform
                        attributeName="transform"
                        type="rotate"
                        from="0 18 18"
                        to="360 18 18"
                        dur="0.9s"
                        repeatCount="indefinite" />
                </path>
                <circle fill="currentColor" cx="36" cy="18" r="1">
                    <animateTransform
                        attributeName="transform"
                        type="rotate"
                        from="0 18 18"
                        to="360 18 18"
                        dur="0.9s"
                        repeatCount="indefinite" />
                </circle>
            </g>
        </g>
    </svg>;
};
